import { WireAdapter, ShadowRootTheGoodPart } from "lwc";

import { Menu, MenuState, DEFAULT_MENU_STATE } from "common/menu";

export type MenuAdapterValue = {
  close: () => void;
  open: () => void;
  state: MenuState;
};

export type MenuAdapterConfig = {
  items: unknown[];
  template: ShadowRootTheGoodPart;
};

export const MENU_ADAPTER_DEFAULT_VALUE = {
  close: () => {},
  open: () => {},
  state: {
    ...DEFAULT_MENU_STATE,
  },
};

export class MenuAdapter implements WireAdapter {
  menu: Menu | null = null;

  private openAfterConnect = false;
  private setValue: (entry: MenuAdapterValue) => void;

  constructor(setValue: (entries: MenuAdapterValue) => void) {
    this.setValue = setValue;
    this.setValue({
      ...MENU_ADAPTER_DEFAULT_VALUE,
      open: () => {
        this.openAfterConnect = true;
      },
    });
  }

  private get value(): MenuAdapterValue {
    let menu = this.menu!;
    return {
      close: () => menu.close(),
      open: () => menu.open(),
      state: menu.getState(),
    };
  }

  connect() {}

  disconnect() {
    if (this.menu) this.menu.teardown();
  }

  update(config: MenuAdapterConfig) {
    if (!this.menu) {
      this.menu = new Menu(config.template, () => {
        if (!this.menu) return;
        this.setValue(this.value);
      });
      if (this.openAfterConnect) {
        this.menu.open();
      }
    }
    this.menu.setState({ count: config.items.length });
  }
}
